/*
 * @Author: hsc 1971130203@qq.com
 * @Date: 2022-07-25 15:15:52
 * @LastEditors: hsc 1971130203@qq.com
 * @LastEditTime: 2022-07-29 14:05:27
 * @FilePath: \agency-new\src\api\classifymanage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from '@/api/config';

const classifyManage = {
  getClassificationManagementTree(data) {
    return axios.get(`${process.env.BASE_URL}/classificationManagement/getClassificationManagementTree`,  {params:data});
  },

  updateClassificationManagement(data){
    return axios.post(`${process.env.BASE_URL}/classificationManagement/updateClassificationManagement`, data)
  },


  addClassificationManagementList(data){
    return axios.post(`${process.env.BASE_URL}/classificationManagement/addClassificationManagementList`, data)
  },

  disableClassificationManagement(data){
    return axios.delete(`${process.env.BASE_URL}/classificationManagement/disableClassificationManagement/${data}`, )
  },

  getClassificationManagementList(data){
    return axios.get(`${process.env.BASE_URL}/classificationManagement/getClassificationManagementList`,  {params:data});
  },

  getGoodsList(data){
    return axios.post(`${process.env.BASE_URL}/goodsInfo/getPageList`, data)
  },

  addClassificationGoodsRelationList(data){
    return axios.post(`${process.env.BASE_URL}/classificationGoodsRelation/addClassificationGoodsRelationList`, data)
  },

  getClassificationGoodsInfoList(data){
    return axios.post(`${process.env.BASE_URL}/classificationGoodsRelation/getClassificationGoodsInfoList`, data)
  },

  getClassificationGoodsInfoListByVideo(data) {
    return axios.post(`${process.env.BASE_URL}/classificationGoodsRelation/getClassificationGoodsInfoListByVideo`, data)
  },
  updateClassificationGoodsRelation(data) {
    return axios.post(`${process.env.BASE_URL}/classificationGoodsRelation/updateClassificationGoodsRelation`, data)
  },

  getGuideList(data){
    return axios.post(`${process.env.BASE_URL}/subjectGuide/pageList`, data)
  },

  getClassificationSubjectGuideList(data){
    return axios.post(`${process.env.BASE_URL}/classificationGoodsRelation/getClassificationSubjectGuideList`, data)
  },

  getClassificationCount(data){
    return axios.get(`${process.env.BASE_URL}/classificationGoodsRelation/getClassificationCount`,  {params:data})
  },

  deleteClassificationGoodsRelation(data){
    return axios.delete(`${process.env.BASE_URL}/classificationGoodsRelation/deleteClassificationGoodsRelation/${data}`)
  },

  sortClassificationManagement(data){
    return axios.post(`${process.env.BASE_URL}/classificationManagement/sortClassificationManagement`, data)
  },
}

export default classifyManage;



// WEBPACK FOOTER //
// ./src/api/classifyManage.js